export default {
  HANDLE_SUCCESS_GET_CAMPAIGNS: 'handleSuccessGetCampaigns',
  TOGGLE_CREATE_CAMPAIGN_MODAL: 'toggleCreateCampaignModal',
  CREATE_CAMPAIGN_IN_PROGRESS: 'createCampaignInProgress',
  TOGGLE_CHOOSE_CAMPAIGN_MODAL: 'toggleChooseCampaignModal',
  TOGGLE_MOBILE_CAMPAIGN_MODAL: 'toggleMobileCampaignModal',
};



// WEBPACK FOOTER //
// ./src/app/main/campaigns/constants/action-types.js